import { createSelector } from 'reselect';
import { TeamArmy } from '@Models';
import { AppState } from '@Redux/store';
import { TeamArmyView } from './create/view/TeamArmyView';

export const getMyTeam = (state: AppState): Array<TeamArmy> =>
  state.myTeam.entity?.teamArmies ?? [];

export const getMatchTeamArmyIds = (state: AppState): Array<string> =>
  (state.matches.entity?.map((item) => item.myTeamArmyId) ?? []).concat(
    state.matches.entity?.map((item) => item.opponentTeamArmyId) ?? [],
  );

export const getDrawTeamArmyIds = (state: AppState): Array<string> =>
  [
    state.myDraw.entity?.myTeamArmyId ?? null,
    state.opponentDraw.entity?.propositionTeamArmyOneId ?? null,
    state.opponentDraw.entity?.propositionTeamArmyTwoId ?? null,
  ].filter((item): item is string => !!item);

export const myTeamArmies = createSelector(
  [getMyTeam, getMatchTeamArmyIds, getDrawTeamArmyIds],
  (teamArmies, matchTeamArmyIds, drawTeamArmyIds): Array<TeamArmyView> => {
    return teamArmies
      .filter((army) => !matchTeamArmyIds.includes(army.id))
      .filter((army) => !drawTeamArmyIds.includes(army.id))
      .map((item) => TeamArmyView.fromTeamArmy(item)!);
  },
);
